import { Component, Input } from '@angular/core';

import { ConsumerBusinessHandlerProvider } from '../../providers/consumer-business-handler';

@Component({
  selector: 'consumer-money-debit-list',
  templateUrl: 'consumer-money-debit-list.html'
})
export class ConsumerMoneyDebitListComponent {
	@Input('business') business;

	constructor(
		public mainProvider: ConsumerBusinessHandlerProvider, 	
	) {
	}

	ngOnInit(){
		this.mainProvider.getUserDebits({
			businessId: this.business.Id, 
			page: 1, 
			size: 20, 
		});
	}
}



// WEBPACK FOOTER //
// ./src/components/consumer-money-debit-list/consumer-money-debit-list.ts